import { render, staticRenderFns } from "./bill.vue?vue&type=template&id=77ffb25e"
import script from "./bill.vue?vue&type=script&lang=js"
export * from "./bill.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports